export default __webpack_public_path__ + "static/media/pic4.cc5e77dc.svg";